// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-contain {
	width: 80%;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%,-50%);
	border: 1px solid blue;
}
.error-info {
	width: 50%;
	float: left;
}
.error-image {
	display: block;
	width: 50%;
	float: right;
	position: relative;
}

.server-offline-page {
	background: #fff;
}
.icon {
	position: relative;
	
/* 	top: 50%;
	left: 50%;
	transform: translate(-50%,-50%); */
	width: 600px;
	height: 600px;
}
.bg {
	position: absolute;
	top: 20%;
	left: 30%;
	transform: scale(2);
	filter: drop-shadow(2px 4px 0px #f0f5ff);
}

.boy {
	height: 300px;
	width: 300px;
	
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	filter: drop-shadow(5px 3px 0px rgba(0,0,0,0.1));
}
.boy-head {
	position: absolute;
	left: 25px;
	top: 40px;
}
.boy-shirt {
	width: 215px;
	position: absolute;
	height: 150px;
	bottom: 3px;
	background: #b8d3ff;
	left: 50%;
	transform: translate(-50%, 0);
	border-radius: 50px 50px 0 0;
}
.boy-badge {
	width: 35px;
	height: 50px;
	border-radius: 5px;
	background: #16304f;
	position: absolute;
	top: 85px;
	left: 65px;
	filter: drop-shadow(3px 2px 0px #a0bff2);
}
.boy-badge::before {
	content: '';
	width: 10px;
	height: 15px;
	background: #aaa;
	position: absolute;
	border-radius: 3px;
	left: 50%;
	top: -8px;
	transform: translate(-50%,0);
}
.image {
	width: 100%;
	height: 20px;
	background: white;
	position: absolute;
	top: 10px
}
.image i {
	margin-left: 5px;
	margin-top: 3px;
}


.boy-face {
	transform: scale3d(3.5,3.5,3.5);
	position: absolute;
	top: 130px;
	left: 135px;
	filter: drop-shadow(0px 2px 0px #a0bff2);
}
.boy-hair {
	z-index: 5;
	transform: scale3d(3.8,3.8,3.8);
	position: absolute;
	top: 140px;
	left: 143px;
	filter: drop-shadow(0px 1px 0px rgba(0,0,0,0.2));
}
.boy-hair-lick-1, .boy-hair-lick-2 {
	position: absolute;
}
.boy-hair-lick-1 {
	transform: scale3d(1.5,1.5,1.5) rotate(15deg);
	left: 130px;
	top: -30px;
}
.boy-hair-lick-2 {
	transform: rotate(-20deg);
	left: 122px;
	top: -47px;
}

.boy-mouth {
	height: 3px;
	width: 20px;
	background: #222;
	position: absolute;
	left: 115px;
	top: 130px;
	border-radius: 3px;
}

.boy-eyes {
	height: 15px;
	width: 100px;
	position: absolute;
	z-index: 6;
	left: 75px;
	top: 85px;
}
.left-eye, .right-eye {
	width: 15px;
	height: 15px;
	background: #000;
	position: absolute;
	border-radius: 50%;
	animation-name: blink;
	animation-duration: 5s;
	animation-timing-function: linear;
	animation-iteration-count: infinite;
}
.left-eye {
	left: 0;
}
.right-eye {
	right: 0;
}
@keyframes blink {
	18% {
		height: 15px;
		top: 0;
	}
	20% {
		height: 3px;
		top: 5px;
	}
	22% {
		top: 0;
		height: 15px;
	}
}

.boy-brows {
	height: 15px;
	width: 100px;
	position: absolute;
	z-index: 2;
	left: 75px;
	top: 65px;
}
.left-brow, .right-brow {
	width: 30px;
	height: 10px;
	background: #111;
	position: absolute;
	top: 5px;
	border-radius: 3px;
	animation-duration: 5s;
	animation-timing-function: linear;
	animation-iteration-count: infinite;
}

.left-brow {
	left: 0;
	transform: rotate(0);
	animation-name: left-brow;
}
.right-brow {
	right: 0;
	transform: rotate(0);
	animation-name: right-brow;
}

@keyframes left-brow {
	10% {transform: rotate(0);}
	15% {transform: rotate(-15deg);}
	60% {transform: rotate(-15deg);}
	65% {transform: rotate(0);}
}

@keyframes right-brow {
	10% {transform: rotate(0);}
	15% {transform: rotate(15deg);}
	60% {transform: rotate(15deg);}
	65% {transform: rotate(0);}
}

.boy-ears {
	width: 170px;
	height: 30px;
	position: absolute;
	top: 85px;
	left: 40px;
}
.left-ear, .right-ear {
	height: 30px;
	width: 20px;
	background: #f2daa0;
	position: absolute;
}
.left-ear {
	left: 0;
	border-radius: 50% 0 50% 50%;
}
.right-ear {
	right: 2px;
	border-radius: 0 50% 50% 50%;
}

.boy-stache {
	position: absolute;
	left: 88px;
	top: 93px;
	transform: scale(0.5);
}

.palm-left, .palm-right {
	position: absolute;
	bottom: 20px;
	width: 70px;
	height: 50px;
	border-radius: 10px 10px 50% 50%;
	background: #dbc07b;
	z-index: 5;
}
.palm-left {
	left: 176px;
	bottom: 150px;
}
.palm-right {
	right: 176px;
	bottom: 150px;
}
.server-offline-page ul {
	padding: 0;
	position: absolute;
	bottom: 73px;
	list-style-type: none;
}
.fingers-left {
	bottom: 203px;
	left: 176px;
}
.fingers-right {
	bottom: 203px;
	right: 176px;
}
.server-offline-page li::before {
	content: '';
	position: absolute;
	height: 2px;
	background: #e8cd8b;
	left: 3px;
	right: 3px;
	top: 0px;
}
.server-offline-page li {
	display: inline;
	position: absolute;
	width: 15px;
	height: 35px;
	background: #f2daa0;
	border-radius: 15px;
	border: 1px solid #f2daa0;
	border-top: 2px solid #fff4d9;
	animation-duration: 2s;
	animation-iteration-count: infinite;
	animation-timing-function: linear;
	top: 10px;
	overflow: hidden;
	z-index: 5;
}
.server-offline-page li::after {
	content: '';
	position: absolute;
	bottom: 3px;
	right: 2px;
	left: 2px;
	height: 8px;
	background: #ffeab8;
	border-radius: 0 0 50% 50%;
	border-top: 1px solid #e8cd8b;
	
}
.server-offline-page li:nth-child(5)::after, .server-offline-page li:nth-child(5)::before {
	display: none;
}
.fingers-left li:nth-child(1) {
	width: 10px;
	height: 30px;
	top: 15px;
	animation-name: l-fin-1;
}
.fingers-left li:nth-child(2) {
	left: 14px;
	animation-name: l-fin-2;
}
.fingers-left li:nth-child(3) {
	left: 33px;
	animation-name: l-fin-3;
}
.fingers-left li:nth-child(4) {
	left: 52px;
	animation-name: l-fin-4;
}
.fingers-left li:nth-child(5) {
	left: 60px;
	height: 15px;
	width: 35px;
	top: 35px;
	animation-name: l-fin-5;
	transform: rotate(-25deg);
	z-index: 4;
	background: #dbc07b;
}


.fingers-right li:nth-child(1) {
	width: 10px;
	height: 30px;
	top: 15px;
	right: 0;
	animation-name: r-fin-1;
}
.fingers-right li:nth-child(2) {
	right: 14px;
	animation-name: r-fin-2;
}
.fingers-right li:nth-child(3) {
	right: 33px;
	animation-name: r-fin-3;
}
.fingers-right li:nth-child(4) {
	right: 52px;
	animation-name: r-fin-4;
}
.fingers-right li:nth-child(5) {
	right: 60px;
	height: 15px;
	width: 35px;
	top: 35px;
	animation-name: r-fin-5;
	transform: rotate(25deg);
	z-index: 4;
	background: #dbc07b;
}



.keyboard {
	height: 30px;
	width: 260px;
	left: 50%;
	transform: translate(-50%,0);
	bottom: 130px;
	background: #222;
	position: absolute;
	border-radius: 5px;
	border-bottom: 3px solid #111;
	z-index: 6;
}
.keyboard .key {
	position: absolute;
	top: -5px;
	height: 10px;
	width: 15px;
	background: #222;
	border-radius: 3px;
	animation-duration: 2s;
	animation-iteration-count: infinite;
	animation-timing-function: linear;
	border-top: 2px solid #333;
}
.keyboard .key:first-child {
	animation-name: key-1;
	left: 3px;
}
.keyboard .key:nth-child(2) {
	animation-name: key-2;
	left: 21px;
}
.keyboard .key:nth-child(3) {
	animation-name: key-3;
	left: 40px;
}
.keyboard .key:nth-child(4) {
	animation-name: key-4;
	left: 59px;
}
.keyboard .key:nth-child(5) {
	animation-name: key-5;
	left: 80px;
	width: 100px;
}
.keyboard .key:nth-child(6) {
	right: 59px;
	animation-name: key-6;
}
.keyboard .key:nth-child(7) {
	animation-name: key-7; 
	right: 40px;
}
.keyboard .key:nth-child(8) {
	animation-name: key-8; 
	right: 21px;
}
.keyboard .key:nth-child(9) {
	animation-name: key-9; 
	right: 3px;
}
.keyboard .key:nth-child(10) {
	animation-name: key-10;
}
.keyboard .key:nth-child(11) {
	animation-name: key-11;
}
.keyboard .key:nth-child(12) {
	animation-name: key-12;
}
.keyboard .key:nth-child(13) {
	animation-name: key-13;
}


@keyframes r-fin-3 {
	4% {top: 10px;} 
	5% {top: 15px;} 
	10% {top: 10px;}
}
@keyframes key-7 {
	7% {top: -5px;} 
	8% {top: -1px;} 
	13% {top: -5px;}
}

@keyframes l-fin-2 {
	9% {top: 10px;}
	10% {top: 15px;}
	15% {top: 10px;}
}
@keyframes key-2 {
	12% {top: -5px;}
	13% {top: -1px;}
	17% {top: -5px;}
}


@keyframes r-fin-2 {
	14% {top: 10px;}
	15% {top: 15px;}
	20% {top: 10px;}
}
@keyframes key-8 {
	17% {top: -5px;}
	18% {top: -1px;}
	22% {top: -5px;}
}

@keyframes l-fin-3 {
	19% {top: 10px;}
	20% {top: 15px;}
  25% {top: 10px;}
}
@keyframes key-3 {
	22% {top: -5px;}
	23% {top: -1px;}
	27% {top: -5px;}
}

@keyframes r-fin-5 {
	24% {top: 35px;}
	25% {top: 40px;}
	30% {top: 35px;}
}
@keyframes key-5 {
	27% {top: -5px; transform: rotate(0);}
	28% {top: -2px; transform: rotate(3deg);}
	32% {top: -5px; transform: rotate(0);}
	42% {top: -5px; transform: rotate(0);}
	43% {top: -2px; transform: rotate(-3deg);}
	47% {top: -5px; transform: rotate(0);}
}

@keyframes l-fin-4 {
	29% {top: 10px;}
	30% {top: 15px;}
	35% {top: 10px;}
}
@keyframes key-4 {
	32% {top: -5px;}
	33% {top: -1px;}
	37% {top: -5px;}
}

@keyframes r-fin-4 {
	34% {top: 10px;}
	35% {top: 15px;}
	40% {top: 10px;}
}
@keyframes key-6 {
	37% {top: -5px;}
	38% {top: -1px;}
	42% {top: -5px;	}
}

@keyframes l-fin-5 {
	39% {top: 35px;}
	40% {top: 40px;}
	45% {top: 35px;}
}

@keyframes r-fin-1 {
	44% {top: 15px;}
	45% {top: 20px;}
	50% {top: 15px;}
}
@keyframes key-9 {
	47% {top: -5px;}
	48% {top: -1px;}
	52% {top: -5px;}
}

@keyframes l-fin-1 {
	49% {top: 15px;}
	50% {top: 20px;}
	55% {top: 15px;}
}
@keyframes key-1 {
	52% {top: -5px;}
	53% {top: -1px;}
	57% {top: -5px;}
}


.tear {
	transform: scale(0.5);
	position: absolute;
	top: 60px;
	right: 20px;
	z-index: 5;
	animation-name: tear-fall;
	animation-duration: 3s;
	animation-timing-function: linear;
	animation-iteration-count: infinite;
	opacity: 0;
}
@keyframes tear-fall {
	50% {
		opacity: 0;
		top: 60px;
	}
	60% {
		opacity: 1;
		top: 75px;
	}
	80% {
		top: 100px;
	}
	85% {
		top: 100px;
	}
	90% {
		opacity: 0;
	}
}
.server {
	width: 100px;
	height: 200px;
	background: #222;
	position: absolute;
	right: 120px;
	top: 50%;
	transform: translate(0, -50%);
	border-radius: 5px;
}
.server-disc {
	position: absolute;
	height: 20px;
	background: #333;
	top: 30px;
	left: 5px;
	right: 5px;
	border-radius: 3px;
	border-bottom: 2px solid #111;
	border-top: 1px solid #444;
}
.server-disc::before {
	width: 10px;
	height: 10px;
	content: '';
	position: absolute;
	top: 5px;
	left: 5px;
	border-radius: 50%;
	background: #222;
}
.server-disc::after {
	width: 20px;
	height: 10px;
	content: '';
	position: absolute;
	top: 5px;
	right: 5px;
	border-radius: 3px;
	background: #222;
}
.server-shock {
	position: absolute;
	top: -75px;
	left: -20px;
}

.server-lights {
	position: absolute;
	height: 60px;
	background: #333;
	top: 70px;
	left: 5px;
	right: 5px;
}
.server-lights span {
	width: 5px;
	height: 5px;
	position: absolute;
	background: #4aff71;
	right: 5px;
	border-radius: 50%;
	opacity: 1;
	animation-timing-function: linear;
	animation-iteration-count: infinite;
}
.server-lights span:nth-child(1) {
	background: #4aff71;
	animation-name: blink-1;
	animation-duration: 2s;
	top: 5px;
}
.server-lights span:nth-child(2) {
	background: #ff4a65;
	animation-name: blink-2;
	animation-duration: 3s;
	top: 15px;
}

@keyframes blink-1 {
	50% { opacity: 0; }
}
@keyframes blink-2 {
	50% { opacity: 0; }
}

.mo-fire {
	width: 200px;
	height: auto;
	position: absolute;
	left: 30px;
	margin-left: -100px;
	bottom: -50px;
	transform: scale(0.8) rotate(20deg);
}
.mo-fire svg {
	width: 100%;
	height: auto;
	position: relative;
	filter: drop-shadow(2px 4px 16px rgba(255, 119, 0, 0.5));
}
.flame {
	animation-name: flamefly;
	animation-duration: 1s;
	animation-timing-function: linear;
	animation-iteration-count: infinite;
	opacity: 0;
	transform-origin: 50% 50% 0;
}
.flame.one {
	animation-delay: 1s;
	animation-duration: 2s;
}
.flame3.two{
	animation-duration: 4s;
	animation-delay: 1s;
}

.flame-main {
	animation-name: flameWobble;
	animation-duration: 2s;
	animation-timing-function: linear;
	animation-iteration-count: infinite;
}
.flame-main.one {
	animation-duration: 3s;
	animation-delay: 1s;
}
.flame-main.two {
	animation-duration: 2s;
	animation-delay: 1s;
}
.flame-main.three {
	animation-duration: 1s;
	animation-delay: 2s;
}
.flame-main.four {
	animation-duration: 2s;
	animation-delay: 3s;
}
.flame-main.five {
	animation-duration: 1s;
	animation-delay: 3s;
}
@keyframes flameWobble {
	50% {
		transform: scale(1,1.2) translate(0, -30px) rotate(-2deg);
	}
}
@keyframes flamefly {
	0%{
		transform: translate(0) rotate(180deg);
	}
	50% {
		opacity: 1;
	}
	100% {
		transform: translate(-20px, -100px) rotate(180deg);
		opacity: 0;
	}
}



.icon-bg {
	position: absolute;
	top: 55%;
	left: 50%;
	transform: translate(-50%,-50%);
	width: 500px;
	height: 500px;
}

.icon-bg svg {
	position: absolute;
	top: 0%;
	left: 0%;
	filter: drop-shadow(3px 3px 0px #f0f5ff)
}

`, "",{"version":3,"sources":["webpack://./src/components/ServerOffline/ServerOffline.css"],"names":[],"mappings":"AAAA;CACC,UAAU;CACV,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,+BAA+B;CAC/B,sBAAsB;AACvB;AACA;CACC,UAAU;CACV,WAAW;AACZ;AACA;CACC,cAAc;CACd,UAAU;CACV,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;AACA;CACC,kBAAkB;;AAEnB;;mCAEmC;CAClC,YAAY;CACZ,aAAa;AACd;AACA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,mBAAmB;CACnB,wCAAwC;AACzC;;AAEA;CACC,aAAa;CACb,YAAY;;CAEZ,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,gCAAgC;CAChC,gDAAgD;AACjD;AACA;CACC,kBAAkB;CAClB,UAAU;CACV,SAAS;AACV;AACA;CACC,YAAY;CACZ,kBAAkB;CAClB,aAAa;CACb,WAAW;CACX,mBAAmB;CACnB,SAAS;CACT,6BAA6B;CAC7B,4BAA4B;AAC7B;AACA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;CACnB,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,wCAAwC;AACzC;AACA;CACC,WAAW;CACX,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,SAAS;CACT,SAAS;CACT,4BAA4B;AAC7B;AACA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,kBAAkB;CAClB;AACD;AACA;CACC,gBAAgB;CAChB,eAAe;AAChB;;;AAGA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,wCAAwC;AACzC;AACA;CACC,UAAU;CACV,+BAA+B;CAC/B,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,gDAAgD;AACjD;AACA;CACC,kBAAkB;AACnB;AACA;CACC,6CAA6C;CAC7C,WAAW;CACX,UAAU;AACX;AACA;CACC,yBAAyB;CACzB,WAAW;CACX,UAAU;AACX;;AAEA;CACC,WAAW;CACX,WAAW;CACX,gBAAgB;CAChB,kBAAkB;CAClB,WAAW;CACX,UAAU;CACV,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,kBAAkB;CAClB,UAAU;CACV,UAAU;CACV,SAAS;AACV;AACA;CACC,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iCAAiC;CACjC,mCAAmC;AACpC;AACA;CACC,OAAO;AACR;AACA;CACC,QAAQ;AACT;AACA;CACC;EACC,YAAY;EACZ,MAAM;CACP;CACA;EACC,WAAW;EACX,QAAQ;CACT;CACA;EACC,MAAM;EACN,YAAY;CACb;AACD;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,kBAAkB;CAClB,UAAU;CACV,UAAU;CACV,SAAS;AACV;AACA;CACC,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,kBAAkB;CAClB,QAAQ;CACR,kBAAkB;CAClB,sBAAsB;CACtB,iCAAiC;CACjC,mCAAmC;AACpC;;AAEA;CACC,OAAO;CACP,oBAAoB;CACpB,yBAAyB;AAC1B;AACA;CACC,QAAQ;CACR,oBAAoB;CACpB,0BAA0B;AAC3B;;AAEA;CACC,KAAK,oBAAoB,CAAC;CAC1B,KAAK,yBAAyB,CAAC;CAC/B,KAAK,yBAAyB,CAAC;CAC/B,KAAK,oBAAoB,CAAC;AAC3B;;AAEA;CACC,KAAK,oBAAoB,CAAC;CAC1B,KAAK,wBAAwB,CAAC;CAC9B,KAAK,wBAAwB,CAAC;CAC9B,KAAK,oBAAoB,CAAC;AAC3B;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,kBAAkB;CAClB,SAAS;CACT,UAAU;AACX;AACA;CACC,YAAY;CACZ,WAAW;CACX,mBAAmB;CACnB,kBAAkB;AACnB;AACA;CACC,OAAO;CACP,4BAA4B;AAC7B;AACA;CACC,UAAU;CACV,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,SAAS;CACT,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,YAAY;CACZ,gCAAgC;CAChC,mBAAmB;CACnB,UAAU;AACX;AACA;CACC,WAAW;CACX,aAAa;AACd;AACA;CACC,YAAY;CACZ,aAAa;AACd;AACA;CACC,UAAU;CACV,kBAAkB;CAClB,YAAY;CACZ,qBAAqB;AACtB;AACA;CACC,aAAa;CACb,WAAW;AACZ;AACA;CACC,aAAa;CACb,YAAY;AACb;AACA;CACC,WAAW;CACX,kBAAkB;CAClB,WAAW;CACX,mBAAmB;CACnB,SAAS;CACT,UAAU;CACV,QAAQ;AACT;AACA;CACC,eAAe;CACf,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,mBAAmB;CACnB,yBAAyB;CACzB,6BAA6B;CAC7B,sBAAsB;CACtB,mCAAmC;CACnC,iCAAiC;CACjC,SAAS;CACT,gBAAgB;CAChB,UAAU;AACX;AACA;CACC,WAAW;CACX,kBAAkB;CAClB,WAAW;CACX,UAAU;CACV,SAAS;CACT,WAAW;CACX,mBAAmB;CACnB,0BAA0B;CAC1B,6BAA6B;;AAE9B;AACA;CACC,aAAa;AACd;AACA;CACC,WAAW;CACX,YAAY;CACZ,SAAS;CACT,uBAAuB;AACxB;AACA;CACC,UAAU;CACV,uBAAuB;AACxB;AACA;CACC,UAAU;CACV,uBAAuB;AACxB;AACA;CACC,UAAU;CACV,uBAAuB;AACxB;AACA;CACC,UAAU;CACV,YAAY;CACZ,WAAW;CACX,SAAS;CACT,uBAAuB;CACvB,yBAAyB;CACzB,UAAU;CACV,mBAAmB;AACpB;;;AAGA;CACC,WAAW;CACX,YAAY;CACZ,SAAS;CACT,QAAQ;CACR,uBAAuB;AACxB;AACA;CACC,WAAW;CACX,uBAAuB;AACxB;AACA;CACC,WAAW;CACX,uBAAuB;AACxB;AACA;CACC,WAAW;CACX,uBAAuB;AACxB;AACA;CACC,WAAW;CACX,YAAY;CACZ,WAAW;CACX,SAAS;CACT,uBAAuB;CACvB,wBAAwB;CACxB,UAAU;CACV,mBAAmB;AACpB;;;;AAIA;CACC,YAAY;CACZ,YAAY;CACZ,SAAS;CACT,4BAA4B;CAC5B,aAAa;CACb,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,6BAA6B;CAC7B,UAAU;AACX;AACA;CACC,kBAAkB;CAClB,SAAS;CACT,YAAY;CACZ,WAAW;CACX,gBAAgB;CAChB,kBAAkB;CAClB,sBAAsB;CACtB,mCAAmC;CACnC,iCAAiC;CACjC,0BAA0B;AAC3B;AACA;CACC,qBAAqB;CACrB,SAAS;AACV;AACA;CACC,qBAAqB;CACrB,UAAU;AACX;AACA;CACC,qBAAqB;CACrB,UAAU;AACX;AACA;CACC,qBAAqB;CACrB,UAAU;AACX;AACA;CACC,qBAAqB;CACrB,UAAU;CACV,YAAY;AACb;AACA;CACC,WAAW;CACX,qBAAqB;AACtB;AACA;CACC,qBAAqB;CACrB,WAAW;AACZ;AACA;CACC,qBAAqB;CACrB,WAAW;AACZ;AACA;CACC,qBAAqB;CACrB,UAAU;AACX;AACA;CACC,sBAAsB;AACvB;AACA;CACC,sBAAsB;AACvB;AACA;CACC,sBAAsB;AACvB;AACA;CACC,sBAAsB;AACvB;;;AAGA;CACC,IAAI,SAAS,CAAC;CACd,IAAI,SAAS,CAAC;CACd,KAAK,SAAS,CAAC;AAChB;AACA;CACC,IAAI,SAAS,CAAC;CACd,IAAI,SAAS,CAAC;CACd,KAAK,SAAS,CAAC;AAChB;;AAEA;CACC,IAAI,SAAS,CAAC;CACd,KAAK,SAAS,CAAC;CACf,KAAK,SAAS,CAAC;AAChB;AACA;CACC,KAAK,SAAS,CAAC;CACf,KAAK,SAAS,CAAC;CACf,KAAK,SAAS,CAAC;AAChB;;;AAGA;CACC,KAAK,SAAS,CAAC;CACf,KAAK,SAAS,CAAC;CACf,KAAK,SAAS,CAAC;AAChB;AACA;CACC,KAAK,SAAS,CAAC;CACf,KAAK,SAAS,CAAC;CACf,KAAK,SAAS,CAAC;AAChB;;AAEA;CACC,KAAK,SAAS,CAAC;CACf,KAAK,SAAS,CAAC;EACd,KAAK,SAAS,CAAC;AACjB;AACA;CACC,KAAK,SAAS,CAAC;CACf,KAAK,SAAS,CAAC;CACf,KAAK,SAAS,CAAC;AAChB;;AAEA;CACC,KAAK,SAAS,CAAC;CACf,KAAK,SAAS,CAAC;CACf,KAAK,SAAS,CAAC;AAChB;AACA;CACC,KAAK,SAAS,EAAE,oBAAoB,CAAC;CACrC,KAAK,SAAS,EAAE,uBAAuB,CAAC;CACxC,KAAK,SAAS,EAAE,oBAAoB,CAAC;CACrC,KAAK,SAAS,EAAE,oBAAoB,CAAC;CACrC,KAAK,SAAS,EAAE,wBAAwB,CAAC;CACzC,KAAK,SAAS,EAAE,oBAAoB,CAAC;AACtC;;AAEA;CACC,KAAK,SAAS,CAAC;CACf,KAAK,SAAS,CAAC;CACf,KAAK,SAAS,CAAC;AAChB;AACA;CACC,KAAK,SAAS,CAAC;CACf,KAAK,SAAS,CAAC;CACf,KAAK,SAAS,CAAC;AAChB;;AAEA;CACC,KAAK,SAAS,CAAC;CACf,KAAK,SAAS,CAAC;CACf,KAAK,SAAS,CAAC;AAChB;AACA;CACC,KAAK,SAAS,CAAC;CACf,KAAK,SAAS,CAAC;CACf,KAAK,SAAS,EAAE;AACjB;;AAEA;CACC,KAAK,SAAS,CAAC;CACf,KAAK,SAAS,CAAC;CACf,KAAK,SAAS,CAAC;AAChB;;AAEA;CACC,KAAK,SAAS,CAAC;CACf,KAAK,SAAS,CAAC;CACf,KAAK,SAAS,CAAC;AAChB;AACA;CACC,KAAK,SAAS,CAAC;CACf,KAAK,SAAS,CAAC;CACf,KAAK,SAAS,CAAC;AAChB;;AAEA;CACC,KAAK,SAAS,CAAC;CACf,KAAK,SAAS,CAAC;CACf,KAAK,SAAS,CAAC;AAChB;AACA;CACC,KAAK,SAAS,CAAC;CACf,KAAK,SAAS,CAAC;CACf,KAAK,SAAS,CAAC;AAChB;;;AAGA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,SAAS;CACT,WAAW;CACX,UAAU;CACV,yBAAyB;CACzB,sBAAsB;CACtB,iCAAiC;CACjC,mCAAmC;CACnC,UAAU;AACX;AACA;CACC;EACC,UAAU;EACV,SAAS;CACV;CACA;EACC,UAAU;EACV,SAAS;CACV;CACA;EACC,UAAU;CACX;CACA;EACC,UAAU;CACX;CACA;EACC,UAAU;CACX;AACD;AACA;CACC,YAAY;CACZ,aAAa;CACb,gBAAgB;CAChB,kBAAkB;CAClB,YAAY;CACZ,QAAQ;CACR,6BAA6B;CAC7B,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,YAAY;CACZ,gBAAgB;CAChB,SAAS;CACT,SAAS;CACT,UAAU;CACV,kBAAkB;CAClB,6BAA6B;CAC7B,0BAA0B;AAC3B;AACA;CACC,WAAW;CACX,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,kBAAkB;CAClB,gBAAgB;AACjB;AACA;CACC,WAAW;CACX,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,QAAQ;CACR,UAAU;CACV,kBAAkB;CAClB,gBAAgB;AACjB;AACA;CACC,kBAAkB;CAClB,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,gBAAgB;CAChB,SAAS;CACT,SAAS;CACT,UAAU;AACX;AACA;CACC,UAAU;CACV,WAAW;CACX,kBAAkB;CAClB,mBAAmB;CACnB,UAAU;CACV,kBAAkB;CAClB,UAAU;CACV,iCAAiC;CACjC,mCAAmC;AACpC;AACA;CACC,mBAAmB;CACnB,uBAAuB;CACvB,sBAAsB;CACtB,QAAQ;AACT;AACA;CACC,mBAAmB;CACnB,uBAAuB;CACvB,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,MAAM,UAAU,EAAE;AACnB;AACA;CACC,MAAM,UAAU,EAAE;AACnB;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,kBAAkB;CAClB,UAAU;CACV,mBAAmB;CACnB,aAAa;CACb,mCAAmC;AACpC;AACA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,wDAAwD;AACzD;AACA;CACC,wBAAwB;CACxB,sBAAsB;CACtB,iCAAiC;CACjC,mCAAmC;CACnC,UAAU;CACV,2BAA2B;AAC5B;AACA;CACC,mBAAmB;CACnB,sBAAsB;AACvB;AACA;CACC,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC,2BAA2B;CAC3B,sBAAsB;CACtB,iCAAiC;CACjC,mCAAmC;AACpC;AACA;CACC,sBAAsB;CACtB,mBAAmB;AACpB;AACA;CACC,sBAAsB;CACtB,mBAAmB;AACpB;AACA;CACC,sBAAsB;CACtB,mBAAmB;AACpB;AACA;CACC,sBAAsB;CACtB,mBAAmB;AACpB;AACA;CACC,sBAAsB;CACtB,mBAAmB;AACpB;AACA;CACC;EACC,yDAAyD;CAC1D;AACD;AACA;CACC;EACC,sCAAsC;CACvC;CACA;EACC,UAAU;CACX;CACA;EACC,kDAAkD;EAClD,UAAU;CACX;AACD;;;;AAIA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,+BAA+B;CAC/B,YAAY;CACZ,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,QAAQ;CACR;AACD","sourcesContent":[".error-contain {\r\n\twidth: 80%;\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\tleft: 50%;\r\n\ttransform: translate(-50%,-50%);\r\n\tborder: 1px solid blue;\r\n}\r\n.error-info {\r\n\twidth: 50%;\r\n\tfloat: left;\r\n}\r\n.error-image {\r\n\tdisplay: block;\r\n\twidth: 50%;\r\n\tfloat: right;\r\n\tposition: relative;\r\n}\r\n\r\n.server-offline-page {\r\n\tbackground: #fff;\r\n}\r\n.icon {\r\n\tposition: relative;\r\n\t\r\n/* \ttop: 50%;\r\n\tleft: 50%;\r\n\ttransform: translate(-50%,-50%); */\r\n\twidth: 600px;\r\n\theight: 600px;\r\n}\r\n.bg {\r\n\tposition: absolute;\r\n\ttop: 20%;\r\n\tleft: 30%;\r\n\ttransform: scale(2);\r\n\tfilter: drop-shadow(2px 4px 0px #f0f5ff);\r\n}\r\n\r\n.boy {\r\n\theight: 300px;\r\n\twidth: 300px;\r\n\t\r\n\tposition: absolute;\r\n\tleft: 50%;\r\n\ttop: 50%;\r\n\ttransform: translate(-50%, -50%);\r\n\tfilter: drop-shadow(5px 3px 0px rgba(0,0,0,0.1));\r\n}\r\n.boy-head {\r\n\tposition: absolute;\r\n\tleft: 25px;\r\n\ttop: 40px;\r\n}\r\n.boy-shirt {\r\n\twidth: 215px;\r\n\tposition: absolute;\r\n\theight: 150px;\r\n\tbottom: 3px;\r\n\tbackground: #b8d3ff;\r\n\tleft: 50%;\r\n\ttransform: translate(-50%, 0);\r\n\tborder-radius: 50px 50px 0 0;\r\n}\r\n.boy-badge {\r\n\twidth: 35px;\r\n\theight: 50px;\r\n\tborder-radius: 5px;\r\n\tbackground: #16304f;\r\n\tposition: absolute;\r\n\ttop: 85px;\r\n\tleft: 65px;\r\n\tfilter: drop-shadow(3px 2px 0px #a0bff2);\r\n}\r\n.boy-badge::before {\r\n\tcontent: '';\r\n\twidth: 10px;\r\n\theight: 15px;\r\n\tbackground: #aaa;\r\n\tposition: absolute;\r\n\tborder-radius: 3px;\r\n\tleft: 50%;\r\n\ttop: -8px;\r\n\ttransform: translate(-50%,0);\r\n}\r\n.image {\r\n\twidth: 100%;\r\n\theight: 20px;\r\n\tbackground: white;\r\n\tposition: absolute;\r\n\ttop: 10px\r\n}\r\n.image i {\r\n\tmargin-left: 5px;\r\n\tmargin-top: 3px;\r\n}\r\n\r\n\r\n.boy-face {\r\n\ttransform: scale3d(3.5,3.5,3.5);\r\n\tposition: absolute;\r\n\ttop: 130px;\r\n\tleft: 135px;\r\n\tfilter: drop-shadow(0px 2px 0px #a0bff2);\r\n}\r\n.boy-hair {\r\n\tz-index: 5;\r\n\ttransform: scale3d(3.8,3.8,3.8);\r\n\tposition: absolute;\r\n\ttop: 140px;\r\n\tleft: 143px;\r\n\tfilter: drop-shadow(0px 1px 0px rgba(0,0,0,0.2));\r\n}\r\n.boy-hair-lick-1, .boy-hair-lick-2 {\r\n\tposition: absolute;\r\n}\r\n.boy-hair-lick-1 {\r\n\ttransform: scale3d(1.5,1.5,1.5) rotate(15deg);\r\n\tleft: 130px;\r\n\ttop: -30px;\r\n}\r\n.boy-hair-lick-2 {\r\n\ttransform: rotate(-20deg);\r\n\tleft: 122px;\r\n\ttop: -47px;\r\n}\r\n\r\n.boy-mouth {\r\n\theight: 3px;\r\n\twidth: 20px;\r\n\tbackground: #222;\r\n\tposition: absolute;\r\n\tleft: 115px;\r\n\ttop: 130px;\r\n\tborder-radius: 3px;\r\n}\r\n\r\n.boy-eyes {\r\n\theight: 15px;\r\n\twidth: 100px;\r\n\tposition: absolute;\r\n\tz-index: 6;\r\n\tleft: 75px;\r\n\ttop: 85px;\r\n}\r\n.left-eye, .right-eye {\r\n\twidth: 15px;\r\n\theight: 15px;\r\n\tbackground: #000;\r\n\tposition: absolute;\r\n\tborder-radius: 50%;\r\n\tanimation-name: blink;\r\n\tanimation-duration: 5s;\r\n\tanimation-timing-function: linear;\r\n\tanimation-iteration-count: infinite;\r\n}\r\n.left-eye {\r\n\tleft: 0;\r\n}\r\n.right-eye {\r\n\tright: 0;\r\n}\r\n@keyframes blink {\r\n\t18% {\r\n\t\theight: 15px;\r\n\t\ttop: 0;\r\n\t}\r\n\t20% {\r\n\t\theight: 3px;\r\n\t\ttop: 5px;\r\n\t}\r\n\t22% {\r\n\t\ttop: 0;\r\n\t\theight: 15px;\r\n\t}\r\n}\r\n\r\n.boy-brows {\r\n\theight: 15px;\r\n\twidth: 100px;\r\n\tposition: absolute;\r\n\tz-index: 2;\r\n\tleft: 75px;\r\n\ttop: 65px;\r\n}\r\n.left-brow, .right-brow {\r\n\twidth: 30px;\r\n\theight: 10px;\r\n\tbackground: #111;\r\n\tposition: absolute;\r\n\ttop: 5px;\r\n\tborder-radius: 3px;\r\n\tanimation-duration: 5s;\r\n\tanimation-timing-function: linear;\r\n\tanimation-iteration-count: infinite;\r\n}\r\n\r\n.left-brow {\r\n\tleft: 0;\r\n\ttransform: rotate(0);\r\n\tanimation-name: left-brow;\r\n}\r\n.right-brow {\r\n\tright: 0;\r\n\ttransform: rotate(0);\r\n\tanimation-name: right-brow;\r\n}\r\n\r\n@keyframes left-brow {\r\n\t10% {transform: rotate(0);}\r\n\t15% {transform: rotate(-15deg);}\r\n\t60% {transform: rotate(-15deg);}\r\n\t65% {transform: rotate(0);}\r\n}\r\n\r\n@keyframes right-brow {\r\n\t10% {transform: rotate(0);}\r\n\t15% {transform: rotate(15deg);}\r\n\t60% {transform: rotate(15deg);}\r\n\t65% {transform: rotate(0);}\r\n}\r\n\r\n.boy-ears {\r\n\twidth: 170px;\r\n\theight: 30px;\r\n\tposition: absolute;\r\n\ttop: 85px;\r\n\tleft: 40px;\r\n}\r\n.left-ear, .right-ear {\r\n\theight: 30px;\r\n\twidth: 20px;\r\n\tbackground: #f2daa0;\r\n\tposition: absolute;\r\n}\r\n.left-ear {\r\n\tleft: 0;\r\n\tborder-radius: 50% 0 50% 50%;\r\n}\r\n.right-ear {\r\n\tright: 2px;\r\n\tborder-radius: 0 50% 50% 50%;\r\n}\r\n\r\n.boy-stache {\r\n\tposition: absolute;\r\n\tleft: 88px;\r\n\ttop: 93px;\r\n\ttransform: scale(0.5);\r\n}\r\n\r\n.palm-left, .palm-right {\r\n\tposition: absolute;\r\n\tbottom: 20px;\r\n\twidth: 70px;\r\n\theight: 50px;\r\n\tborder-radius: 10px 10px 50% 50%;\r\n\tbackground: #dbc07b;\r\n\tz-index: 5;\r\n}\r\n.palm-left {\r\n\tleft: 176px;\r\n\tbottom: 150px;\r\n}\r\n.palm-right {\r\n\tright: 176px;\r\n\tbottom: 150px;\r\n}\r\n.server-offline-page ul {\r\n\tpadding: 0;\r\n\tposition: absolute;\r\n\tbottom: 73px;\r\n\tlist-style-type: none;\r\n}\r\n.fingers-left {\r\n\tbottom: 203px;\r\n\tleft: 176px;\r\n}\r\n.fingers-right {\r\n\tbottom: 203px;\r\n\tright: 176px;\r\n}\r\n.server-offline-page li::before {\r\n\tcontent: '';\r\n\tposition: absolute;\r\n\theight: 2px;\r\n\tbackground: #e8cd8b;\r\n\tleft: 3px;\r\n\tright: 3px;\r\n\ttop: 0px;\r\n}\r\n.server-offline-page li {\r\n\tdisplay: inline;\r\n\tposition: absolute;\r\n\twidth: 15px;\r\n\theight: 35px;\r\n\tbackground: #f2daa0;\r\n\tborder-radius: 15px;\r\n\tborder: 1px solid #f2daa0;\r\n\tborder-top: 2px solid #fff4d9;\r\n\tanimation-duration: 2s;\r\n\tanimation-iteration-count: infinite;\r\n\tanimation-timing-function: linear;\r\n\ttop: 10px;\r\n\toverflow: hidden;\r\n\tz-index: 5;\r\n}\r\n.server-offline-page li::after {\r\n\tcontent: '';\r\n\tposition: absolute;\r\n\tbottom: 3px;\r\n\tright: 2px;\r\n\tleft: 2px;\r\n\theight: 8px;\r\n\tbackground: #ffeab8;\r\n\tborder-radius: 0 0 50% 50%;\r\n\tborder-top: 1px solid #e8cd8b;\r\n\t\r\n}\r\n.server-offline-page li:nth-child(5)::after, .server-offline-page li:nth-child(5)::before {\r\n\tdisplay: none;\r\n}\r\n.fingers-left li:nth-child(1) {\r\n\twidth: 10px;\r\n\theight: 30px;\r\n\ttop: 15px;\r\n\tanimation-name: l-fin-1;\r\n}\r\n.fingers-left li:nth-child(2) {\r\n\tleft: 14px;\r\n\tanimation-name: l-fin-2;\r\n}\r\n.fingers-left li:nth-child(3) {\r\n\tleft: 33px;\r\n\tanimation-name: l-fin-3;\r\n}\r\n.fingers-left li:nth-child(4) {\r\n\tleft: 52px;\r\n\tanimation-name: l-fin-4;\r\n}\r\n.fingers-left li:nth-child(5) {\r\n\tleft: 60px;\r\n\theight: 15px;\r\n\twidth: 35px;\r\n\ttop: 35px;\r\n\tanimation-name: l-fin-5;\r\n\ttransform: rotate(-25deg);\r\n\tz-index: 4;\r\n\tbackground: #dbc07b;\r\n}\r\n\r\n\r\n.fingers-right li:nth-child(1) {\r\n\twidth: 10px;\r\n\theight: 30px;\r\n\ttop: 15px;\r\n\tright: 0;\r\n\tanimation-name: r-fin-1;\r\n}\r\n.fingers-right li:nth-child(2) {\r\n\tright: 14px;\r\n\tanimation-name: r-fin-2;\r\n}\r\n.fingers-right li:nth-child(3) {\r\n\tright: 33px;\r\n\tanimation-name: r-fin-3;\r\n}\r\n.fingers-right li:nth-child(4) {\r\n\tright: 52px;\r\n\tanimation-name: r-fin-4;\r\n}\r\n.fingers-right li:nth-child(5) {\r\n\tright: 60px;\r\n\theight: 15px;\r\n\twidth: 35px;\r\n\ttop: 35px;\r\n\tanimation-name: r-fin-5;\r\n\ttransform: rotate(25deg);\r\n\tz-index: 4;\r\n\tbackground: #dbc07b;\r\n}\r\n\r\n\r\n\r\n.keyboard {\r\n\theight: 30px;\r\n\twidth: 260px;\r\n\tleft: 50%;\r\n\ttransform: translate(-50%,0);\r\n\tbottom: 130px;\r\n\tbackground: #222;\r\n\tposition: absolute;\r\n\tborder-radius: 5px;\r\n\tborder-bottom: 3px solid #111;\r\n\tz-index: 6;\r\n}\r\n.keyboard .key {\r\n\tposition: absolute;\r\n\ttop: -5px;\r\n\theight: 10px;\r\n\twidth: 15px;\r\n\tbackground: #222;\r\n\tborder-radius: 3px;\r\n\tanimation-duration: 2s;\r\n\tanimation-iteration-count: infinite;\r\n\tanimation-timing-function: linear;\r\n\tborder-top: 2px solid #333;\r\n}\r\n.keyboard .key:first-child {\r\n\tanimation-name: key-1;\r\n\tleft: 3px;\r\n}\r\n.keyboard .key:nth-child(2) {\r\n\tanimation-name: key-2;\r\n\tleft: 21px;\r\n}\r\n.keyboard .key:nth-child(3) {\r\n\tanimation-name: key-3;\r\n\tleft: 40px;\r\n}\r\n.keyboard .key:nth-child(4) {\r\n\tanimation-name: key-4;\r\n\tleft: 59px;\r\n}\r\n.keyboard .key:nth-child(5) {\r\n\tanimation-name: key-5;\r\n\tleft: 80px;\r\n\twidth: 100px;\r\n}\r\n.keyboard .key:nth-child(6) {\r\n\tright: 59px;\r\n\tanimation-name: key-6;\r\n}\r\n.keyboard .key:nth-child(7) {\r\n\tanimation-name: key-7; \r\n\tright: 40px;\r\n}\r\n.keyboard .key:nth-child(8) {\r\n\tanimation-name: key-8; \r\n\tright: 21px;\r\n}\r\n.keyboard .key:nth-child(9) {\r\n\tanimation-name: key-9; \r\n\tright: 3px;\r\n}\r\n.keyboard .key:nth-child(10) {\r\n\tanimation-name: key-10;\r\n}\r\n.keyboard .key:nth-child(11) {\r\n\tanimation-name: key-11;\r\n}\r\n.keyboard .key:nth-child(12) {\r\n\tanimation-name: key-12;\r\n}\r\n.keyboard .key:nth-child(13) {\r\n\tanimation-name: key-13;\r\n}\r\n\r\n\r\n@keyframes r-fin-3 {\r\n\t4% {top: 10px;} \r\n\t5% {top: 15px;} \r\n\t10% {top: 10px;}\r\n}\r\n@keyframes key-7 {\r\n\t7% {top: -5px;} \r\n\t8% {top: -1px;} \r\n\t13% {top: -5px;}\r\n}\r\n\r\n@keyframes l-fin-2 {\r\n\t9% {top: 10px;}\r\n\t10% {top: 15px;}\r\n\t15% {top: 10px;}\r\n}\r\n@keyframes key-2 {\r\n\t12% {top: -5px;}\r\n\t13% {top: -1px;}\r\n\t17% {top: -5px;}\r\n}\r\n\r\n\r\n@keyframes r-fin-2 {\r\n\t14% {top: 10px;}\r\n\t15% {top: 15px;}\r\n\t20% {top: 10px;}\r\n}\r\n@keyframes key-8 {\r\n\t17% {top: -5px;}\r\n\t18% {top: -1px;}\r\n\t22% {top: -5px;}\r\n}\r\n\r\n@keyframes l-fin-3 {\r\n\t19% {top: 10px;}\r\n\t20% {top: 15px;}\r\n  25% {top: 10px;}\r\n}\r\n@keyframes key-3 {\r\n\t22% {top: -5px;}\r\n\t23% {top: -1px;}\r\n\t27% {top: -5px;}\r\n}\r\n\r\n@keyframes r-fin-5 {\r\n\t24% {top: 35px;}\r\n\t25% {top: 40px;}\r\n\t30% {top: 35px;}\r\n}\r\n@keyframes key-5 {\r\n\t27% {top: -5px; transform: rotate(0);}\r\n\t28% {top: -2px; transform: rotate(3deg);}\r\n\t32% {top: -5px; transform: rotate(0);}\r\n\t42% {top: -5px; transform: rotate(0);}\r\n\t43% {top: -2px; transform: rotate(-3deg);}\r\n\t47% {top: -5px; transform: rotate(0);}\r\n}\r\n\r\n@keyframes l-fin-4 {\r\n\t29% {top: 10px;}\r\n\t30% {top: 15px;}\r\n\t35% {top: 10px;}\r\n}\r\n@keyframes key-4 {\r\n\t32% {top: -5px;}\r\n\t33% {top: -1px;}\r\n\t37% {top: -5px;}\r\n}\r\n\r\n@keyframes r-fin-4 {\r\n\t34% {top: 10px;}\r\n\t35% {top: 15px;}\r\n\t40% {top: 10px;}\r\n}\r\n@keyframes key-6 {\r\n\t37% {top: -5px;}\r\n\t38% {top: -1px;}\r\n\t42% {top: -5px;\t}\r\n}\r\n\r\n@keyframes l-fin-5 {\r\n\t39% {top: 35px;}\r\n\t40% {top: 40px;}\r\n\t45% {top: 35px;}\r\n}\r\n\r\n@keyframes r-fin-1 {\r\n\t44% {top: 15px;}\r\n\t45% {top: 20px;}\r\n\t50% {top: 15px;}\r\n}\r\n@keyframes key-9 {\r\n\t47% {top: -5px;}\r\n\t48% {top: -1px;}\r\n\t52% {top: -5px;}\r\n}\r\n\r\n@keyframes l-fin-1 {\r\n\t49% {top: 15px;}\r\n\t50% {top: 20px;}\r\n\t55% {top: 15px;}\r\n}\r\n@keyframes key-1 {\r\n\t52% {top: -5px;}\r\n\t53% {top: -1px;}\r\n\t57% {top: -5px;}\r\n}\r\n\r\n\r\n.tear {\r\n\ttransform: scale(0.5);\r\n\tposition: absolute;\r\n\ttop: 60px;\r\n\tright: 20px;\r\n\tz-index: 5;\r\n\tanimation-name: tear-fall;\r\n\tanimation-duration: 3s;\r\n\tanimation-timing-function: linear;\r\n\tanimation-iteration-count: infinite;\r\n\topacity: 0;\r\n}\r\n@keyframes tear-fall {\r\n\t50% {\r\n\t\topacity: 0;\r\n\t\ttop: 60px;\r\n\t}\r\n\t60% {\r\n\t\topacity: 1;\r\n\t\ttop: 75px;\r\n\t}\r\n\t80% {\r\n\t\ttop: 100px;\r\n\t}\r\n\t85% {\r\n\t\ttop: 100px;\r\n\t}\r\n\t90% {\r\n\t\topacity: 0;\r\n\t}\r\n}\r\n.server {\r\n\twidth: 100px;\r\n\theight: 200px;\r\n\tbackground: #222;\r\n\tposition: absolute;\r\n\tright: 120px;\r\n\ttop: 50%;\r\n\ttransform: translate(0, -50%);\r\n\tborder-radius: 5px;\r\n}\r\n.server-disc {\r\n\tposition: absolute;\r\n\theight: 20px;\r\n\tbackground: #333;\r\n\ttop: 30px;\r\n\tleft: 5px;\r\n\tright: 5px;\r\n\tborder-radius: 3px;\r\n\tborder-bottom: 2px solid #111;\r\n\tborder-top: 1px solid #444;\r\n}\r\n.server-disc::before {\r\n\twidth: 10px;\r\n\theight: 10px;\r\n\tcontent: '';\r\n\tposition: absolute;\r\n\ttop: 5px;\r\n\tleft: 5px;\r\n\tborder-radius: 50%;\r\n\tbackground: #222;\r\n}\r\n.server-disc::after {\r\n\twidth: 20px;\r\n\theight: 10px;\r\n\tcontent: '';\r\n\tposition: absolute;\r\n\ttop: 5px;\r\n\tright: 5px;\r\n\tborder-radius: 3px;\r\n\tbackground: #222;\r\n}\r\n.server-shock {\r\n\tposition: absolute;\r\n\ttop: -75px;\r\n\tleft: -20px;\r\n}\r\n\r\n.server-lights {\r\n\tposition: absolute;\r\n\theight: 60px;\r\n\tbackground: #333;\r\n\ttop: 70px;\r\n\tleft: 5px;\r\n\tright: 5px;\r\n}\r\n.server-lights span {\r\n\twidth: 5px;\r\n\theight: 5px;\r\n\tposition: absolute;\r\n\tbackground: #4aff71;\r\n\tright: 5px;\r\n\tborder-radius: 50%;\r\n\topacity: 1;\r\n\tanimation-timing-function: linear;\r\n\tanimation-iteration-count: infinite;\r\n}\r\n.server-lights span:nth-child(1) {\r\n\tbackground: #4aff71;\r\n\tanimation-name: blink-1;\r\n\tanimation-duration: 2s;\r\n\ttop: 5px;\r\n}\r\n.server-lights span:nth-child(2) {\r\n\tbackground: #ff4a65;\r\n\tanimation-name: blink-2;\r\n\tanimation-duration: 3s;\r\n\ttop: 15px;\r\n}\r\n\r\n@keyframes blink-1 {\r\n\t50% { opacity: 0; }\r\n}\r\n@keyframes blink-2 {\r\n\t50% { opacity: 0; }\r\n}\r\n\r\n.mo-fire {\r\n\twidth: 200px;\r\n\theight: auto;\r\n\tposition: absolute;\r\n\tleft: 30px;\r\n\tmargin-left: -100px;\r\n\tbottom: -50px;\r\n\ttransform: scale(0.8) rotate(20deg);\r\n}\r\n.mo-fire svg {\r\n\twidth: 100%;\r\n\theight: auto;\r\n\tposition: relative;\r\n\tfilter: drop-shadow(2px 4px 16px rgba(255, 119, 0, 0.5));\r\n}\r\n.flame {\r\n\tanimation-name: flamefly;\r\n\tanimation-duration: 1s;\r\n\tanimation-timing-function: linear;\r\n\tanimation-iteration-count: infinite;\r\n\topacity: 0;\r\n\ttransform-origin: 50% 50% 0;\r\n}\r\n.flame.one {\r\n\tanimation-delay: 1s;\r\n\tanimation-duration: 2s;\r\n}\r\n.flame3.two{\r\n\tanimation-duration: 4s;\r\n\tanimation-delay: 1s;\r\n}\r\n\r\n.flame-main {\r\n\tanimation-name: flameWobble;\r\n\tanimation-duration: 2s;\r\n\tanimation-timing-function: linear;\r\n\tanimation-iteration-count: infinite;\r\n}\r\n.flame-main.one {\r\n\tanimation-duration: 3s;\r\n\tanimation-delay: 1s;\r\n}\r\n.flame-main.two {\r\n\tanimation-duration: 2s;\r\n\tanimation-delay: 1s;\r\n}\r\n.flame-main.three {\r\n\tanimation-duration: 1s;\r\n\tanimation-delay: 2s;\r\n}\r\n.flame-main.four {\r\n\tanimation-duration: 2s;\r\n\tanimation-delay: 3s;\r\n}\r\n.flame-main.five {\r\n\tanimation-duration: 1s;\r\n\tanimation-delay: 3s;\r\n}\r\n@keyframes flameWobble {\r\n\t50% {\r\n\t\ttransform: scale(1,1.2) translate(0, -30px) rotate(-2deg);\r\n\t}\r\n}\r\n@keyframes flamefly {\r\n\t0%{\r\n\t\ttransform: translate(0) rotate(180deg);\r\n\t}\r\n\t50% {\r\n\t\topacity: 1;\r\n\t}\r\n\t100% {\r\n\t\ttransform: translate(-20px, -100px) rotate(180deg);\r\n\t\topacity: 0;\r\n\t}\r\n}\r\n\r\n\r\n\r\n.icon-bg {\r\n\tposition: absolute;\r\n\ttop: 55%;\r\n\tleft: 50%;\r\n\ttransform: translate(-50%,-50%);\r\n\twidth: 500px;\r\n\theight: 500px;\r\n}\r\n\r\n.icon-bg svg {\r\n\tposition: absolute;\r\n\ttop: 0%;\r\n\tleft: 0%;\r\n\tfilter: drop-shadow(3px 3px 0px #f0f5ff)\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
